<template>
  <div
    class="trending-topics"
    data-test-id="trending-topics"
  >
    <div class="community-hub__section-header">
      <img
        src="/common/nexus/trending-topics.png"
        alt=""
        class="community-hub__section-header-image"
      >
      <h2
        class="community-hub__section-heading"
        data-test-id="trending-topics-heading"
      >Trending Topics</h2>
    </div>
    <loading-spinner v-if="loading !== 0 " />
    <div v-else class="trending-topics__container">
      <div
        class="trending-topics__forums"
        data-test-id="trending-topics-forums"
      >
        <p class="trending-topics__label">Forums</p>
        <thread-teaser
          v-for="thread in forums"
          :key="`trending-thread-${thread.id}`"
          :thread="thread"
          make-heading-h3
        />
      </div>
      <div
        class="trending-topics__stories"
        data-test-id="trending-topics-stories"
      >
        <p class="trending-topics__label">Stories</p>
        <post-teaser
          v-for="story in stories"
          :key="`trending-story-${story.id}`"
          :post="story"
          make-heading-h3
        />
      </div>
    </div>
  </div>
</template>

<script>
import ThreadTeaser from '@/components/Forum/ThreadTeaser.vue';
import PostTeaser from '@/components/Posts/PostTeaser.vue';
import { GET_TRENDING_TOPICS } from '@/graphql/queries/search-queries';

export default {
  name: 'TrendingTopics',
  components: {
    ThreadTeaser,
    PostTeaser,
  },
  data() {
    return {
      trendingTopics: {},
      loading: 0,
    };
  },
  computed: {
    forums() {
      if (this.trendingTopics && this.trendingTopics.forums) {
        return this.trendingTopics.forums;
      }
      return [];
    },
    stories() {
      if (this.trendingTopics && this.trendingTopics.stories) {
        return this.trendingTopics.stories;
      }
      return [];
    },
  },
  apollo: {
    trendingTopics: {
      query: GET_TRENDING_TOPICS,
      variables() {
        return {
          forumLimit: 3,
          storyLimit: 1,
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_trending-topics';
</style>

<docs>
Renders trending forum topics and stories for the community hub

</docs>
